<template>
    <div v-if="isLoaded" class="slider-app">
        <transition name="fadeshrink" 
			v-for="(s, i) in internalSliderData" 
            :key="i">
            <div class="slider-row" :key="i">
                <div class="slider-col">
                    <div v-if="getTitle(s)" 
                        v-html="getTitle(s)"
                        class="slider-row-title" 
                    ></div>
                    <div v-if="getDescription(s)" 
                        v-html="getDescription(s)"
                        class="slider-row-description" 
                    ></div>
                    <slider-control :data="s" 
                        :id="i"
                        :disabled="loading"
                        @update="updateVal(s, $event)"
                        @drag-end="update(s)" />                    
                </div>  
                <div class="slider-col">
                    <label class="slider-label" 
                        :for="'slider-text-' + i">{{s.title}}</label>
                    <input type="text" 
                        class="slider-input"
                        :id="'slider-text-' + i"
						:disabled="s.disabled || loading"
                        :value="getFormattedValFromObject(s)"
                        @input="handleInput(s, $event)"
                        @focus="handleInputFocus($event)"
                        @blur="handleInputBlur(s, $event)"
                        @keypress.13="handleInputEnter(s, $event)"
                        @keydown="handleInputKeydown(s, $event)">    
                        <!-- :style="loading ? 'opacity: 0;' : ''" -->
                </div>              
            </div>            
        </transition>
        <transition name="fade">
            <div class="slider-loading" v-show="loading">
                <div class="slider-app-lds-roller-container">
                    <div class="slider-app-lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import SliderControl from './SliderControl.vue'

export default {
    name: 'Sliders', 
    props: ['data', 'headingLevel', 'loading'],
    components: {
        SliderControl
    }, 
    data: function(){
        return {
            internalSliderData: [],
			isLoaded: false, 
			isChanging: false,
			hasChanged: false,
            defaultHeadingLevel: 2,
            dummyData: [
                {
                    id: 0,
                    type: 'currency',
                    title: 'Deposit', 
                    description: 'Tell us the amount of money you would like to pay upfront to calculate your regular repayments.',
                    min: 1500, 
                    max: 2000, 
                    interval: 50,
                    val: 1700
                }, 
                {
                    id: 1,
                    type: 'int',
                    title: 'Loan term', 
                    description: 'Decide what time period you would like to pay off your loan.',
                    min: 1, 
                    max: 4, 
                    val: 2
                }, 
                {
                    id: 2,
                    type: 'distance',
                    title: 'Estimated km/yr', 
                    description: 'Please estimate the number of kilometres you drive each year so we can calculate your Toyota’s Guaranteed Future Value.',
                    min: 15000, 
                    max: 50000, 
                    data: [15000,20000,30000,50000],
                    val: 30000
                }
            ]
        };
    }, 
    computed: {
        sliderData(){
            return this.data ? this.data : this.dummyData;
        }, 
        headingTag(){
            return this.headingLevel ? 'h' + this.headingLevel : 'h' + this.defaultHeadingLevel;
        }
    }, 
    methods: { 
        update(s){
            this.$emit('update', {
                data: this.internalSliderData, 
                analytics:s
            });
        },
        updateVal(s, $event){
            s.val = $event;
        },
        handleInputKeydown(s, e){
            if (
                // !e.ctrlKey && 
                // e.keyCode != 17 // ctrl                
                e.keyCode != 13 && // enter
                e.keyCode != 9 && // tab
                e.keyCode != 8 && // backspace
                e.keyCode != 46 && // del
                e.keyCode != 37 && //left
				e.keyCode != 39 && // right
				!(e.ctrlKey && e.keyCode == 65) // ctrl + a
            ){
                const int = parseInt(e.key);
                if (isNaN(int)){
                    e.preventDefault();
                }
            }
        },
        handleInputFocus(e){
            e.target.select();
		},
        handleInputBlur(s, e){
            this.setDataToAllowedValue(s, e);
			this.setDataFromFormattedVal(s, e.target.value);
			this.setInputValToFormattedVal(s.type, e.target, s.val);
			if (this.hasChanged){
				this.update(s);
			}
        },
        handleInputEnter(s, e){
			this.handleInputBlur(s, e);      			
        },
        handleInput(s, e){
            this.hasChanged = true;
            this.setInputValToFormattedVal(s.type, e.target, e.target.value);
		},
		getClosestIntFromList(list, val){
			const closest = list.reduce((prev, curr) => {
				const c = Math.abs(curr - val);
				const p = Math.abs(prev - val);
				return ( c < p ? curr : prev);
			});
			return closest; 
		},
		setDataToAllowedValue(s, e){
			const strippedVal = this.getStrippedVal(e.target.value);
			if (s.data && s.data.length){
				const arr = s.data.filter(o => o.val == strippedVal);
				if (!arr.length){
					e.target.value = this.getClosestIntFromList(s.data, strippedVal);
				}
			}
		},
        setInputValToFormattedVal(type, input, v){
            const newVal = this.getStrippedVal(v);
            if (!isNaN(newVal)){
                const newFormattedVal = this.getFormattedVal(type, newVal);
                input.value = newFormattedVal;
            }
        },
        getTitle(s){
            return `<${this.headingTag}>${s.title}</${this.headingTag}>`;
        },
        getDescription(s){
            return `<p>${s.description}</p>`
        }, 
        setDataFromFormattedVal(s, v){
            let val = this.getStrippedVal(v);
            if (val){
                val = s.max ? Math.min(val, s.max) : val;
                val = s.min ? Math.max(val, s.min) : val;
                s.val = val;
            } 
            else {
                console.log('error setDataFromFormattedVal'); // should never happen
            }
        },
        getStrippedVal(v){
            let ret = v;
            if ('string' == typeof v){
                ret = v.replace('$', '');
                ret = ret.replace(',', '');
                ret = parseInt(ret);
            }
            return ret;
        },
        getFormattedValFromObject(o){
            return this.getFormattedVal(o.type, o.val)
        },
        getFormattedVal(type, val){
            let txt = '';
            switch (type.toLowerCase()){
                case 'int':
                    txt = this.getFormattedInt(val);
                    break;
                case 'currency':
                    txt = this.getFormattedPrice(val);
                    break;
                case 'distance':
                    txt = this.getFormattedDistance(val);
                    break;
                default: 
                    txt = this.getFormattedInt(val);
                break;
            }
            return txt;
        },
        getFormattedInt(v){
            return parseInt(v);
        },
        getFormattedDistance(v){
            return v.toLocaleString(); 
        },
        getFormattedPrice(v){
            return '$' + v.toLocaleString();
        }
	}, 
	watch: {
		sliderData(){
			this.internalSliderData = this.sliderData;
			this.hasChanged = false;
		}
	},	
    mounted(){
		this.internalSliderData = this.sliderData;
        this.isLoaded = true;
	}
}
</script>
<style scoped>
.slider-app
{
    position: relative;
}
.slider-loading
{
    position: absolute;
    top: 0;
    right: 0;
    bottom: -15px;
    left: 0;
    background: #fff;
}
.slider-app-lds-roller-container
{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
}
.slider-app-lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.slider-app-lds-roller div {
  animation: slider-app-lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.slider-app-lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #1a1a1a;
  margin: -4px 0 0 -4px;
}
.slider-app-lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.slider-app-lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.slider-app-lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.slider-app-lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.slider-app-lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.slider-app-lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.slider-app-lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.slider-app-lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.slider-app-lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.slider-app-lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.slider-app-lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.slider-app-lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.slider-app-lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.slider-app-lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.slider-app-lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.slider-app-lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes slider-app-lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
<!--style lang="scss" src="../sass/sliders.scss"></style-->